import React from 'react';

class Display extends React.Component {
    render(){
        return (this.props.if) ? <div className={this.props.className}>{this.props.children}</div>: null;
    }
}

export default Display;


/** WEBPACK FOOTER **
 ** ./src/js/components/parts/display.js
 **/